module.exports = __webpack_public_path__ + "static/solution12-c2cff807a7018aa716ac1e21fbdca44c.png";